export const ConstantsWidthHeightMidia = {
    xs: {
        width: 300,
        height: 342
    },
    sm: {
        // width: 390,
        // height: 445    
        width: 300,
        height: 342
    },
    md: {
        width: 489,
        height: 558
    },
    lg: {
        width: 1024,
        height: 1168
    }
}